import React from "react";
import ReactApexChart from "react-apexcharts";

interface CountryEntry {
    country: string;
    count: number;
}

interface Props {
    data: CountryEntry[];
}

const CountryDistributionChart: React.FC<Props> = ({ data }) => {
    const categories = data.map((entry) => entry.country);
    const series = [
        {
            name: "Count",
            data: data.map((entry) => entry.count),
        },
    ];

    const options: ApexCharts.ApexOptions = {
        chart: {
            type: "bar",
            toolbar: { show: false },
        },
        plotOptions: {
            bar: {
                horizontal: true,
                borderRadius: 6,
                dataLabels: {
                    position: "top",
                },
            },
        },
        dataLabels: {
            enabled: true,
            formatter: (val: number) => `${val}`,
            style: { colors: ["#000000"] },
        },
        colors: ["#5DC6FF"],
        xaxis: {
            categories,
            labels: { trim: true },
        },
        yaxis: {
            title: {
                text: undefined,
            },
        },
        legend: {
            show: false,
        },
    };

    return (
        <ReactApexChart
            options={options}
            series={series}
            type="bar"
            height={360}
        />
    );
};

export default CountryDistributionChart;
